module.exports = __webpack_public_path__ + "img/wait_green.7cb6177b.svg";